module.exports = __webpack_public_path__ + "static/media/Adviesbox_LIC.970c015e.png";